module.exports = __webpack_public_path__ + "media/gocd_logo-549a7ef2044ea73733c199869949c2b0.svg";